import { z } from "zod";

/** GSP Configuration — buyer notification email, field label overrides, date
 * format, data-mapping sets. Everything here is D1-driven per NFR-002: no
 * application code contains a hardcoded configuration literal. */
export const configSettingUpsertSchema = z.object({
  key: z.string().min(1),
  value: z.string(),
  comments: z.string().optional(),
});
export type ConfigSettingUpsertInput = z.infer<typeof configSettingUpsertSchema>;

export const dataMappingUpsertSchema = z.object({
  sourceField: z.string().min(1),
  sourceValue: z.string().min(1),
  destField: z.string().min(1),
  destValue: z.string().min(1),
});
